module.exports = __webpack_public_path__ + "static/media/logo-white.eef4fc1f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-white.svg
 ** module id = 188
 ** module chunks = 0
 **/